import classNames from 'classnames';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren & {
  className?: string;
};

export const BlogPagesShowOnDesktop: React.FC<Props> = ({
  children,
  className,
}) => <div className={classNames('max-lg:hidden', className)}>{children}</div>;
